import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import CustomCursor from "@/components/CustomCursor";

const sections = [
  {
    title: "1. Éditeur du site",
    content: `Le site mirrordigital.cloud est édité par Mirror Digital, société accessible à l'adresse contact@mirrordigital.cloud. Le directeur de la publication est le représentant légal de Mirror Digital.`,
  },
  {
    title: "2. Hébergement",
    content: `Le site est hébergé par IONOS SE, Elgendorfer Str. 57, 56410 Montabaur, Allemagne.`,
  },
  {
    title: "3. Propriété intellectuelle",
    content: `L'ensemble des contenus présents sur le site mirrordigital.cloud (textes, images, graphiques, logo, icônes, etc.) sont la propriété exclusive de Mirror Digital et sont protégés par les lois françaises et internationales relatives à la propriété intellectuelle. Toute reproduction, distribution, modification ou utilisation de ces contenus sans autorisation préalable écrite est strictement interdite.`,
  },
  {
    title: "4. Limitation de responsabilité",
    content: `Mirror Digital s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, Mirror Digital ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à la disposition sur ce site. En conséquence, Mirror Digital décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site.`,
  },
  {
    title: "5. Liens hypertextes",
    content: `Le site mirrordigital.cloud peut contenir des liens hypertextes vers d'autres sites. Mirror Digital n'exerce aucun contrôle sur ces sites tiers et décline toute responsabilité quant à leur contenu ou leurs pratiques en matière de confidentialité.`,
  },
  {
    title: "6. Droit applicable",
    content: `Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.`,
  },
];

export default function Legal() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: "100vh",
      background: "#080b14",
      color: "white",
      fontFamily: "'Syne', sans-serif",
      position: "relative",
      overflow: "hidden",
    }}>
      {/* Background glow */}
      <div style={{
        position: "fixed", top: 0, left: 0, right: 0, bottom: 0, pointerEvents: "none", zIndex: 0,
      }}>
        <div style={{
          position: "absolute", top: "-20%", left: "50%", transform: "translateX(-50%)",
          width: 700, height: 400,
          background: "radial-gradient(ellipse, rgba(124,58,237,0.12) 0%, transparent 70%)",
        }} />
        <div style={{
          position: "absolute", bottom: "10%", right: "10%",
          width: 400, height: 300,
          background: "radial-gradient(ellipse, rgba(6,182,212,0.08) 0%, transparent 70%)",
        }} />
      </div>

      {/* Nav */}
      <motion.nav
        initial={{ opacity: 0, y: -16 }}
        animate={{ opacity: 1, y: 0 }}
        style={{
          position: "fixed", top: 0, left: 0, right: 0, zIndex: 50,
          padding: "18px 32px",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          borderBottom: "1px solid rgba(255,255,255,0.06)",
          background: "rgba(8,11,20,0.85)",
          backdropFilter: "blur(12px)",
        }}
      >
        <button onClick={() => navigate("/")} style={{
          display: "flex", alignItems: "center", gap: 9, background: "none", border: "none", cursor: "pointer",
        }}>
          <div style={{
            width: 32, height: 32, borderRadius: 8,
            background: "linear-gradient(135deg,#7c3aed,#06b6d4)",
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: "0 0 14px rgba(124,58,237,0.5)",
          }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
            </svg>
          </div>
          <span style={{ fontWeight: 800, color: "white", fontSize: 13, letterSpacing: "0.06em" }}>MirrorDigital</span>
        </button>
        <button onClick={() => navigate(-1)} style={{
          background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)",
          color: "rgba(255,255,255,0.6)", padding: "7px 16px", borderRadius: 8,
          cursor: "pointer", fontSize: 13, fontFamily: "'Syne', sans-serif",
        }}>← Retour</button>
      </motion.nav>

      {/* Content */}
      <div style={{ maxWidth: 760, margin: "0 auto", padding: "120px 24px 80px", position: "relative", zIndex: 1 }}>
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div style={{
            display: "inline-block", marginBottom: 16,
            padding: "5px 14px", borderRadius: 20,
            background: "rgba(124,58,237,0.15)", border: "1px solid rgba(124,58,237,0.3)",
            fontSize: 12, color: "#a78bfa", letterSpacing: "0.1em", fontWeight: 700,
          }}>MENTIONS LÉGALES</div>

          <h1 style={{
            fontSize: "clamp(32px, 5vw, 52px)", fontWeight: 900,
            lineHeight: 1.1, marginBottom: 16,
            background: "linear-gradient(135deg, #fff 0%, rgba(255,255,255,0.6) 100%)",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
          }}>Informations légales</h1>

          <p style={{ color: "rgba(255,255,255,0.4)", fontSize: 14, marginBottom: 56 }}>
            Dernière mise à jour : mai 2026
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
            {sections.map((s, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 * i, duration: 0.5 }}
                style={{
                  padding: "28px 32px",
                  background: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.07)",
                  borderRadius: 16,
                  borderLeft: "3px solid rgba(124,58,237,0.5)",
                }}
              >
                <h2 style={{ fontSize: 17, fontWeight: 800, marginBottom: 12, color: "white" }}>{s.title}</h2>
                <p style={{ fontSize: 14, lineHeight: 1.8, color: "rgba(255,255,255,0.55)" }}>{s.content}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}